import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'

// Layouts
import AdminLayout from './components/layout/AdminLayout'

// Auth
import LoginPage from './pages/auth/LoginPage'

// Funnel (Public)
import FunnelLayout from './pages/funnel/FunnelLayout'
import ArbeitgeberFunnelLayout from './pages/funnel-ag/ArbeitgeberFunnelLayout'

// Landing
import LandingPage from './pages/landing/LandingPage'

// Admin (Protected)
import Dashboard from './pages/admin/Dashboard'
import PflegekraefteListe from './pages/admin/PflegekraefteListe'
import PflegekraftDetail from './pages/admin/PflegekraftDetail'
import ArbeitgeberListe from './pages/admin/ArbeitgeberListe'
import ArbeitgeberDetail from './pages/admin/ArbeitgeberDetail'
import StellenListe from './pages/admin/StellenListe'
import StellenDetail from './pages/admin/StellenDetail'
import MatchingView from './pages/admin/MatchingView'
import PipelineBoard from './pages/admin/PipelineBoard'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner" />
        <p>Wird geladen...</p>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export default function App() {
  return (
    <Routes>
      {/* Public: Pflegekraft-Funnel */}
      <Route path="/funnel/*" element={<FunnelLayout />} />

      {/* Public: Arbeitgeber-Funnel */}
      <Route path="/arbeitgeber/*" element={<ArbeitgeberFunnelLayout />} />

      {/* Auth */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected: Admin Dashboard */}
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="pflegekraefte" element={<PflegekraefteListe />} />
        <Route path="pflegekraefte/:id" element={<PflegekraftDetail />} />
        <Route path="arbeitgeber" element={<ArbeitgeberListe />} />
        <Route path="arbeitgeber/:id" element={<ArbeitgeberDetail />} />
        <Route path="stellen" element={<StellenListe />} />
        <Route path="stellen/:id" element={<StellenDetail />} />
        <Route path="matching" element={<MatchingView />} />
        <Route path="pipeline" element={<PipelineBoard />} />
      </Route>

      {/* Landing Page */}
      <Route path="/" element={<LandingPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
